import useWindowWidth from 'helpers/hooks/useBrowerWidth';

type SliderBreakpoints = Record<number, { slidesPerView?: number }>;

/**
 * How many slides the carousel is actually showing at the current viewport width.
 *
 * Needed to answer "are arrows any use here?". Both product sliders decided that from the device
 * size alone, so a Featured Products section pinned to two SKUs still painted prev/next arrows on a
 * desktop showing 4.3 slides — controls that could not move anything. The NZ home page, with five,
 * genuinely needs them, so the answer has to come from the content, not the breakpoint.
 *
 * Swiper breakpoints are MIN-widths, and the largest one at or below the viewport wins — the same
 * rule Swiper applies internally, so this stays in step with what is on screen.
 */
export function useVisibleSlides(base: number, breakpoints: SliderBreakpoints): number {
  const width = useWindowWidth();
  if (width === null) return base;

  return Object.keys(breakpoints)
    .map(Number)
    .filter((min) => width >= min && breakpoints[min]?.slidesPerView != null)
    .sort((a, b) => a - b)
    .reduce((acc, min) => breakpoints[min].slidesPerView as number, base);
}
